import './page-layout.css';

import { BLOB_URL } from '../config';
import { try_get_querystring_value } from '../querystring';
import { LanguageSelector } from './language-selector';

export function PageLayout({
    progress,
    image,
    title,
    description,
    children,
}) {
    return (
        <div className="page-layout">
            <aside className="page-information">
                { renderLogo() }

                {image && <svg className="page-information-image">
                    <use href={image + "#src"} />
                </svg>}

                {progress && <div className="progress-indicator">
                    <div className={"progress-indicator-step " + (progress === "1" ? "active" : "")} />
                    <div className={"progress-indicator-step " + (progress === "2" ? "active" : "")} />
                    <div className={"progress-indicator-step " + (progress === "3" ? "active" : "")} />
                </div>
                }
            </aside>
            <section className="page-content">
                <div className="page-content-header">
                    <LanguageSelector/>
                </div>
                <div className="page-content-center">
                    <div className="page-content-content">
                        {title && <h1 className="page-content-title">{title}</h1> }
                        {description && <div className="page-content-description">{description}</div> }
                        {children}
                    </div>
                </div>
            </section>
        </div>
    );
}

function renderLogo() {
    const [hasCustomerId, customerId] = try_get_querystring_value("customer");
    if (hasCustomerId) {
        const logoUrl = `${BLOB_URL}/customer-branding/${customerId}/logo.png`;
        
        return (
            <div className="page-information-logo">
                <img src={logoUrl} alt="Logo" />
            </div>
        )
    }

    return (
        <svg className="page-information-logo atea-logo">
            <use href="svg/atea.svg#src" />
        </svg>
    )
}